import React from "react";

import { ElementFieldMapping } from "@graffer-inc/cloud-gov-core";
import { DefaultDialog, TextButton } from "@graffer-inc/console-design-kit";

type Props = {
  value: ElementFieldMapping[];
  onChange: (value: ElementFieldMapping[]) => void;
};

export const ElementFieldMappingsJsonEditor: React.FC<Props> = ({
  value,
  onChange,
}) => {
  const [showDialog, setShowDialog] = React.useState(false);
  const [jsonText, setJsonText] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState<string | undefined>();
  const handleButtonClick = React.useCallback(() => {
    setShowDialog(true);
    setJsonText(JSON.stringify(value, null, 2));
    setErrorMessage(undefined);
  }, [setShowDialog, setJsonText, setErrorMessage, value]);
  const handleProceed = React.useCallback(() => {
    let updateValue: ReturnType<typeof JSON.parse>;
    try {
      updateValue = JSON.parse(jsonText);
    } catch (_e) {
      setErrorMessage("JSON の形式が不正です。");
      return;
    }

    if (!Array.isArray(updateValue)) {
      setErrorMessage("配列形式で入力してください。");
      return;
    }

    for (const mapping of updateValue) {
      if (
        !mapping ||
        typeof mapping !== "object" ||
        !("formElementId" in mapping) ||
        typeof mapping.formElementId !== "string" ||
        !("kintoneFieldCode" in mapping) ||
        typeof mapping.kintoneFieldCode !== "string" ||
        Object.keys(mapping).length !== 2
      ) {
        setErrorMessage(
          "配列内の各要素は { formElementId: string, kintoneFieldCode: string } の形式で入力してください。",
        );
        return;
      }
    }

    onChange(updateValue);
    setShowDialog(false);
  }, [jsonText, onChange, setShowDialog, setErrorMessage]);

  return (
    <>
      <TextButton
        icon="TextMultiIcon"
        text="JSON を直接編集する"
        onClick={handleButtonClick}
      />
      {showDialog && (
        <DefaultDialog
          title="JSON を直接編集する"
          contents={
            <div className="field" style={{ width: "480px" }}>
              <textarea
                className="textarea"
                value={jsonText}
                onChange={(e) => {
                  setJsonText(e.target.value);
                  setErrorMessage(undefined);
                }}
                rows={10}
              />
              {errorMessage && <p className="help is-danger">{errorMessage}</p>}
            </div>
          }
          proceedText="確定"
          cancelText="キャンセル"
          onProceed={handleProceed}
          onCancel={() => {
            setShowDialog(false);
          }}
        />
      )}
    </>
  );
};
